const SgiTVEO = function () {
    return {
        // cId: "UIprmsTable",
        isSt: true,
        chkMd: "0",
        // cluDes: "SD_TV_UI_000101",
        // cpB: 0,
        ctlH: '100%',
        ctlN: "表格",
        ctlW: '100%',
        desId: "EP_EO_UI_TV",
        // insName: "UIprms",
        // isBatch: false,
        // isBrdr: false,
        isEd: false,
        isHeaders: false,
        isPg: true,
        isPage: true,//显示翻页器
        size: "small",//表格大小，默认为小
        // isRowNo: false,
        // isSch: true,
        isTbSpt: true,
        isTtl: true,
        // pgRows: 8,
        rowSMd: "9",
        sNo: 0,
        selFirst: false,
        loading: false,//初始加载中
        tbLayout: "fixed", //- | 'auto' | 'fixed' -- 表格元素的 table-layout 属性，设为 fixed 表示内容不会影响列的布局
    }
}
export { SgiTVEO };
export default SgiTVEO;



// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiCompEO/SgiTVEO.js